module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"global":{"company_profiles":{"types":{"asset_manager":"Fondsgesellschaft","financial_service_provider":"Finanzdienstleister","other":"Andere","wealth_manager":"Vermögensverwalter"}}}}}}}')
  delete Component.options._Ctor
}
